module.exports = __webpack_public_path__ + "static/media/appstore-brazil@3x.bc101de0.png";